/**
 * "Not authorized" state for the portal (ADR-0015). Two shapes from one block:
 *
 * - `fullscreen` — a centred standalone screen, for a signed-in user who
 *   reached an app they're NOT a member of while the portal is off (the app
 *   shell would be misleading — they don't belong here at all).
 * - inline (default) — a centred empty-state inside the app shell, for a
 *   member who lacks the role for THIS page (they keep the nav and can move to
 *   a page they can access).
 */
import { Lock } from "lucide-react";

export function NotAuthorized({
  fullscreen = false,
  message,
}: {
  fullscreen?: boolean;
  message?: string;
}) {
  const body = (
    <div className="max-w-sm text-center">
      <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-md bg-muted">
        <Lock className="h-5 w-5 text-muted-foreground/70" />
      </div>
      <h1 className="mt-4 text-base font-semibold text-foreground">Not authorized</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        {message || "You don't have access to this. Ask an administrator if you need it."}
      </p>
    </div>
  );

  if (fullscreen) {
    return (
      <div className="tray-light flex min-h-screen items-center justify-center bg-background p-6">
        {body}
      </div>
    );
  }
  return <div className="flex items-center justify-center py-20">{body}</div>;
}
